import { render, staticRenderFns } from "./MediaOwnersList.vue?vue&type=template&id=c21d0eb8&"
import script from "./MediaOwnersList.vue?vue&type=script&lang=js&"
export * from "./MediaOwnersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports